import React from 'react';
import {t} from 'l10n';

import ProfileLink from 'components/ProfileLink';
import VirtualGiftActions from 'components/virtualgift/VirtualGiftActions';

import {formatDate} from '../../utils/virtualGifts';

import 'sass/list/VirtualGiftList.scss';

function VirtualGiftListItem({virtualGift, actions = false, openFn = null, showDetails = false, viewMessage = false}) {
    let classNames = ['virtual-gift-list-item'];
    if (virtualGift.hidden) classNames.push('hidden');

    return (
        <div className={classNames.join(' ')}>
            <div className="thumbnail" onClick={openFn ? () => openFn(virtualGift) : null}>
                {actions && <VirtualGiftActions virtualGift={virtualGift} className="virtual-gift-actions"/>}
                <img src={virtualGift.thumbnail_url} className="img" alt=""/>
            </div>
            <div className="text">
                <p className="name-gift">
                    {virtualGift.name} {t('given by')} {virtualGift.sender ? <ProfileLink user={virtualGift.sender}/> : t('an anonymous')}
                </p>
                {showDetails &&
                    <div className="details">
                        <span className="date">{formatDate(virtualGift)}</span>
                        <span className="points">{t('%1 Points', virtualGift.points)}</span>
                    </div>
                }
            </div>
            {viewMessage &&
                <div className="view-message">
                    <a onClick={openFn ? () => openFn(virtualGift) : null}>{t('View message')}</a>
                </div>
            }
        </div>
    )
}

export default VirtualGiftListItem;


// WEBPACK FOOTER //
// ./src/components/virtualgift/VirtualGiftItem.js